/* @ngInject */
function guestSummaryService ($q, ConnectorWebService, CONSTANTS, Utils, AssetService) {
  const service = {
    getBriefingSummaryData,
    getAssetPackSummaryData,
    getAssetsByAssetPackId,
    getAssetFoldersByAssetPackId,
    getAssetFoldersByFolderId,
    getAssetsByFolderId,
    getFolderPath,
    downloadAllAssetFoldersAndAssets
  }
  return service

  function getBriefingSummaryData (briefingId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_BRIEFING_SUMMARY, [briefingId])
    return ConnectorWebService.get(url)
  }

  function getAssetPackSummaryData (assetPackId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_SUMMARY, [assetPackId])
    return ConnectorWebService.get(url)
  }

  /**
   * Get assets from the root path of asset pack.
   *
   * @param {object} params
   * @param {number} params.assetPackId Assetpack ID
   * @param {number} [params.top=20] How many registers to take.
   * @param {number} [params.skip=0] How many registers to skip.
   * @returns {Promise}
   */
  async function getAssetsByAssetPackId ({ skip = 0, top = 20, assetPackId }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_ASSETS, [assetPackId])
    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    return _getAssetsWithSrc(url)
  }

  /**
   * Get assets applying src attributes.
   *
   * @param {string} url
   * @returns {Promise}
   */
  async function _getAssetsWithSrc (url) {
    return ConnectorWebService.get(url).then(async data => {
      const assets = await $q.all(
        data.rows?.map(async row => ({
          ...row,
          src: await AssetService.getAssetSrcAttributes(row)
        })) ?? []
      )

      return {
        rows: assets,
        count: data.count ?? 0
      }
    })
  }

  /**
   * Get asset folders from the root path of asset pack.
   *
   * @param {Object} params
   * @param {number} params.assetPackId
   * @param {number} [params.skip=0] How many registers to skip.
   * @param {number} [params.top=20] How many registers to take.
   *
   * @returns {Promise}
   */
  async function getAssetFoldersByAssetPackId ({ skip = 0, top = 20, assetPackId }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_ASSET_FOLDERS, [assetPackId])
    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    return ConnectorWebService.get(url)
  }

  /**
   * Get asset folders from the root path of asset pack.
   *
   * @param {Object} params
   * @param {number} params.assetPackId
   * @param {number} params.folderId
   * @param {number} [params.skip=0] How many registers to skip.
   * @param {number} [params.top=20] How many registers to take.
   *
   * @returns {Promise}
   */
  async function getAssetFoldersByFolderId ({ skip = 0, top = 20, assetPackId, folderId }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_FOLDER_FOLDERS, [assetPackId, folderId])
    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    return ConnectorWebService.get(url)
  }

  /**
   * Get asset folders from the root path of asset pack.
   *
   * @param {Object} params
   * @param {number} params.assetPackId
   * @param {number} params.folderId
   * @param {number} [params.skip=0] How many registers to skip.
   * @param {number} [params.top=20] How many registers to take.
   *
   * @returns {Promise}
   */
  async function getAssetsByFolderId ({ skip = 0, top = 20, assetPackId, folderId }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_FOLDER_ASSETS, [assetPackId, folderId])
    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    return _getAssetsWithSrc(url)
  }

  function getFolderPath (assetPackId, folderId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_FOLDER_PATH, [assetPackId, folderId])
    return ConnectorWebService.get(url)
  }

  /**
   * Download all asset folders and assets from an asset pack.
   *
   * @param {string} assetPackId
   * @returns {Promise}
   */
  function downloadAllAssetFoldersAndAssets (assetPackId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_DOWNLOAD_ALL, [assetPackId])
    return Utils.downloadFile(url)
  }
}

export { guestSummaryService }
